module.exports = __webpack_public_path__ + "img/许昌市.0fe4cf77.png";